import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe display placeholder string if value does not exist
 */
@Pipe({
  name: 'placeholder',
  standalone: false
})
export class PlaceholderPipe implements PipeTransform {
  transform(value: any, placeholder = '-'): any {
    return value || placeholder;
  }

}
